/* Oshea PDP — "This Combo Includes" placement (yt-combo products only).
 *
 * The list is rendered server-side by sections/oshea-pdp.liquid, which lives in
 * the header group, so it starts out nowhere near the product. This moves it to
 * directly under the image gallery.
 *
 * One spot works at every width: the <media-gallery> sits inside
 * .product__media-container on both layouts, followed on desktop by the theme's
 * blocks-below-media (hidden on mobile). Putting the list right after the
 * gallery means "just under the images" on a phone, and under the images in the
 * left column on desktop — never between the two grid columns.
 */
(() => {
  const place = () => {
    const box = document.querySelector('[data-opd-combo]');
    const gallery = document.querySelector('.product__media-container media-gallery, .product__media-container .product__media-gallery');
    if (!box || !gallery || !gallery.parentNode) return;
    if (box.previousElementSibling !== gallery) gallery.parentNode.insertBefore(box, gallery.nextSibling);
    box.hidden = false;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place);
  else place();
})();